export default "__VITE_ASSET__B3NocA7h__"